import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import Layout from '../../../components/Layout';
import Loading from '../../../components/Loading';
import Error from '../../../components/Error';
import UpgradeAccount, { checkForNeedUpgrade } from './UpgradeAccount';
import HotelList from './HotelList';
class Hotels extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      needUpgrade: checkForNeedUpgrade(props.perms),
    };
  }
  componentWillMount() {
    if (this.state.needUpgrade && !this.props.onWaitlist) {
      this.props.checkWaitlist();
    }
    if (this.props.needFetch && !this.state.needUpgrade) {
      this.props.requestHotels();
      this.props.requestSuggestedHotels();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.perms !== nextProps.perms) {
      this.setState({ needUpgrade: checkForNeedUpgrade(nextProps.perms) });
    }
  }
  render() {
    if (this.state.needUpgrade) {
      return (
        <Layout>
          <UpgradeAccount
            onWaitlist={this.props.onWaitlist}
            joinWaitlist={this.props.joinWaitlist}
            waitlistisFetching={this.props.waitlistisFetching}
          />
        </Layout>
      );
    }
    if (this.props.hasError) {
      return (
        <Layout>
          <Error />
        </Layout>
      );
    }
    if (this.props.needFetch || this.props.isFetching) {
      return (
        <Layout>
          <Loading />
        </Layout>
      );
    }
    if (this.props.id) {
      return (
        <Layout>
          <div>{this.props.children}</div>
        </Layout>
      );
    }
    const hasManaged = this.props.hotels.length !== 0;
    const suggested = this.props.suggested.length !== 0;
    return (
      <Layout>
        <div className="content-tours">
          <div className="container-fluid">
            <div className="row tour-head">
              <div className="col-md-12 tour-headText">
                <h2>Manage Hotels</h2>
                <span style={{ float: "right" }}>Total Hotels: {this.props.hotels.length}</span>
                <hr style={{ clear: "both" }} />
              </div>
            </div>
            {hasManaged && (
              <HotelList
                hotels={this.props.hotels}
                requestHotelClaim={() => { }}
                viewHotel={this.props.viewHotel}
                managed
                readOnly={false}
              />
            )}
            {!hasManaged && (
              <div className="row">
                <div className="col-sm-6 col-md-6">
                  <div className="thumbnail">
                    <div className="caption">
                      <Button onClick={this.onClick}>Add a Hotel</Button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {suggested && (
              <div className="row">
                <div className="col-md-12">
                  <h3>Suggested Hotels</h3>
                  <HotelList
                    hotels={this.props.suggested}
                    requestHotelClaim={this.props.requestHotelClaim}
                    viewHotel={this.props.viewHotel}
                    managed={false}
                    readOnly={false}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

Hotels.propTypes = {
  id: PropTypes.string,
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  children: PropTypes.node,
  hotels: PropTypes.arrayOf(PropTypes.object),
  suggested: PropTypes.arrayOf(PropTypes.object),
  requestHotels: PropTypes.func.isRequired,
  requestSuggestedHotels: PropTypes.func.isRequired,
  requestHotelClaim: PropTypes.func.isRequired,
  viewHotel: PropTypes.func.isRequired,
  onWaitlist: PropTypes.bool.isRequired,
  checkWaitlist: PropTypes.func.isRequired,
  joinWaitlist: PropTypes.func.isRequired,
};
Hotels.defaultProps = {
  id: null,
  hotels: [],
  suggested: [],
  children: null,
};

export default Hotels;



// WEBPACK FOOTER //
// src/routes/hotels/components/Hotels.js